var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'lds-dual-ring': _vm.progress === undefined,
    'progress-bar': _vm.progress !== undefined,
  },style:({
    '--value': _vm.progress + '',
  })},[(_vm.progress !== undefined)?_c('span',{staticClass:"progressText"},[_vm._v(_vm._s(Math.round(_vm.progress))+"%")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }